<template>
  <div class="main-content">
    <div class="section grid-wrapper">
      <cargo-ag-grid
        :config-module="'2023032902'"
        :grid-params.sync="gridParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        @gridReady="params=>{gridApi=params.api}"
      />
    </div>
  </div>
</template>

<script>
import * as PriceConstant from '@/class/cargo/model/parameters/PriceConstant'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
export default {
  name: 'MarkupAirDataGrid',
  components: {},
  props: {
    rowData: { type: Array, default: () => [] },
    editable: { type: Boolean, default: false },
    gridOptions: { type: Object, default: () => {} }
  },
  data() {
    return {
      fullscreenLoading: false,
      gridParams: {},
      gridApi: null,
      columnDefs: [
        {
          headerName: ' ', maxWidth: 40, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('Pricing.POL'),
          field: 'pol',
          colId: 'pol',
          width: 200,
          editable: this.editable,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagValue: 'code',
              filterable: true,
              clearable: true,
              tagName: 'englishName',
              selectType: TYPE_NAMES.basic_data_Airport,
              customLabel: (item) => `[${item.code}]${item.englishName}`
            }
          },
          valueFormatter: params => {
            return this.getPolLabel(params.data, 'pol')
          }
        },
        {
          headerName: this.$t('Pricing.POD'),
          field: 'pod',
          colId: 'pod',
          width: 240,
          editable: this.editable,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_Airport,
              filterable: true,
              clearable: true,
              showCustomLabelInOption: true,
              customLabel: (item) => `[${item.code}]${item.englishName}`
            }
          },
          valueFormatter: params => {
            return this.getPodLabel(params.data, 'pod')
          }
        },
        {
          headerName: this.$t('Pricing.Carrier_Air'), field: 'carrier', colId: 'carrier', width: 240,
          tooltip: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          },
          valueFormatter: (params) => {
            return this.dataGridColumnCarrierFunc(params.value)
          },
          editable: this.editable,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_Company,
              customLabel: (item) => `${item.chineseName}` ? `[${item.shortName}]${item.chineseName}` : ' ',
              showCustomLabelInOption: true,
              clearable: true,
              tagValue: 'cmpIdx',
              tagName: 'chineseName',
              methodParams: { airCmp: true },
              filterable: true
            }
          }
        },
        {
          headerName: this.$t('Pricing.Region'),
          field: 'region',
          colId: 'region',
          width: 240,
          editable: this.editable,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_Region,
              filterable: true,
              clearable: true,
              showCustomLabelInOption: true,
              customLabel: (item) => `[${item.code}]${item.name}`
            }
          },
          valueFormatter: params => {
            return this.getRegionLabel(params.data, 'region')
          }
        },
        { headerName: this.$t('Pricing.DepartureDayOfAir'), field: 'frequency', colId: 'frequency', width: 200, editable: this.editable,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            selectProps: {
              filterable: true,
              clearable: false
            },
            options: PriceConstant.AIR_DEPARTURE_DAY,
            tagName: 'chineseName',
            tagValue: 'code'
          },
          valueFormatter: params => {
            return CommonState.getNameByCode(PriceConstant.AIR_DEPARTURE_DAY, params.value)
          }
        },
        { headerName: 'T1 M', field: 't1M', colId: 't1M', width: 200, editable: this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: { isNumber: true }
        },
        { headerName: 'T1 N', field: 't1N', colId: 't1N', width: 200, editable: this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: { isNumber: true }
        },
        { headerName: 'T1 +45', field: 't1P45', colId: 't1P45', width: 200, editable: this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: { isNumber: true }
        },
        { headerName: 'T1 +100', field: 't1P100', colId: 't1P100', width: 200, editable: this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: { isNumber: true }
        },
        { headerName: 'T1 +300', field: 't1P300', colId: 't1P300', width: 200, editable: this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: { isNumber: true }
        },
        { headerName: 'T1 +500', field: 't1P500', colId: 't1P500', width: 200, editable: this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: { isNumber: true }
        },
        { headerName: 'T1 +1000', field: 't1P1000', colId: 't1P1000', width: 200, editable: this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: { isNumber: true }
        },
        { headerName: 'T2 M', field: 't2M', colId: 't2M', width: 200, editable: this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: { isNumber: true }
        },
        { headerName: 'T2 N', field: 't2N', colId: 't2N', width: 200, editable: this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: { isNumber: true }
        },
        { headerName: 'T2 +45', field: 't2P45', colId: 't2P45', width: 200, editable: this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: { isNumber: true }
        },
        { headerName: 'T2 +100', field: 't2P100', colId: 't2P100', width: 200, editable: this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: { isNumber: true }
        },
        { headerName: 'T2 +300', field: 't2P300', colId: 't2P300', width: 200, editable: this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: { isNumber: true }
        },
        { headerName: 'T2 +500', field: 't2P500', colId: 't2P500', width: 200, editable: this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: { isNumber: true }
        },
        { headerName: 'T2 +1000', field: 't2P1000', colId: 't2P1000', width: 200, editable: this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: { isNumber: true }
        },
        { headerName: 'T3 M', field: 't3M', colId: 't3M', width: 200, editable: this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: { isNumber: true }
        },
        { headerName: 'T3 N', field: 't3N', colId: 't3N', width: 200, editable: this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: { isNumber: true }
        },
        { headerName: 'T3 +45', field: 't3P45', colId: 't3P45', width: 200, editable: this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: { isNumber: true }
        },
        { headerName: 'T3 +100', field: 't3P100', colId: 't3P100', width: 200, editable: this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: { isNumber: true }
        },
        { headerName: 'T3 +300', field: 't3P300', colId: 't3P300', width: 200, editable: this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: { isNumber: true }
        },
        { headerName: 'T3 +500', field: 't3P500', colId: 't3P500', width: 200, editable: this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: { isNumber: true }
        },
        { headerName: 'T3 +1000', field: 't3P1000', colId: 't3P1000', width: 200, editable: this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: { isNumber: true }
        }
      ]
    }
  },
  computed: {
    showMainList() {
      return !this.showDetail
    },
    language() {
      return this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName'
    }
  },
  watch: {
  },
  mounted() {
    this.gridOptions.onRowClicked = this.onRowClickedEvent
  },
  methods: {
    setBooleanValue(field) {
      if (this.filter[field]) {
        this.proxy[field] = this.filter[field]
      }
    },
    filterDataGridColumnCarrierFunc(value) {
      const targetFields = ['shortName', 'chineseName', 'englishName']
      let result = ''
      for (const targetField of targetFields) {
        result += ColumnUtils.companyLabelFun(value, targetField, 'cmpIdx')
      }
      return result
    },
    dataGridColumnCarrierFunc(value) {
      if (!value || value === 0) {
        return this.$t('Pricing.ALL')
      }
      return ColumnUtils.companyLabelFun(value, 'shortName', 'cmpIdx')
    },
    onRowClickedEvent(e) {
      const data = e.data
      this.$emit('selectRowChange', data) // 行选中回调
    },
    getRegionLabel(item, field) {
      const language = this.$store.getters.language === 'zh' ? 'name' : 'nameEnglish'
      if (!item.region || item.region === 0) {
        return this.$t('Pricing.ALL')
      }
      return this.getLabel(item, field, language, TYPE_NAMES.basic_data_Region)
    },
    getPolLabel(item, field) {
      if (!item.pol || item.pol === 0) {
        return this.$t('Pricing.ALL')
      }
      return this.getLabel(item, field, 'code', TYPE_NAMES.basic_data_Airport)
    },
    getPodLabel(item, field) {
      if (!item.pod || item.pod === 0) {
        return this.$t('Pricing.ALL')
      }
      return this.getLabel(item, field, 'code', TYPE_NAMES.basic_data_Airport)
    },
    getLabel(item, field, sourceLanguage, cacheKey) {
      if (!item[field]) return ''
      const values = item[field].split(',')
      const valueName = []
      for (const value of values) {
        if (item[field] === 'ALLRG') {
          valueName.push(this.$t('Pricing.ALLRG'))
          continue
        }
        const labelName = ColumnUtils.resolveColumnLabel(cacheKey, 'code', value, sourceLanguage)
        valueName.push(labelName)
      }
      return valueName.join()
    }
  }
}
</script>
<style lang="scss">
</style>

